import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import { Transition } from 'react-transition-group';
import ANIMATION from '../../constants/animation/index.js';
import '../../constants/breakpoints/index.js';
import '../../constants/grid/index.js';
import '../../constants/mediaQueries/index.js';
import '../../constants/boxShadows/primary.js';
import '../../constants/boxShadows/secondary.js';
import { jsx } from '@emotion/react';

var _excluded = ["children"];
var START_STATE = {
  opacity: '0',
  maxHeight: '0'
};

var getStyleForTransitionState = transitionState => {
  switch (transitionState) {
    case 'entering':
      return START_STATE;

    case 'entered':
      return {
        opacity: '1',
        maxHeight: '48px',
        transitionDuration: ANIMATION.defaultTiming,
        transitionProperty: 'max-height, opacity',
        transitionTimingFunction: 'ease-in-out'
      };

    case 'exiting':
      return {
        opacity: '0',
        maxHeight: '0',
        transitionDuration: ANIMATION.defaultTiming,
        transitionProperty: 'max-height, opacity',
        transitionTimingFunction: 'ease-in-out'
      };

    case 'exited':
      return START_STATE;

    default:
      return {};
  }
};

var HelperTransition = _ref => {
  var {
    children: child
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (// eslint-disable-next-line react/jsx-props-no-spreading
    jsx(Transition, _extends({
      timeout: 350
    }, props), transitionState => /*#__PURE__*/React.cloneElement(child, {
      style: getStyleForTransitionState(transitionState)
    }))
  );
};

export { HelperTransition as default };
